<template>
    <div id="wrapper" class="wrapper" v-bind:class="{'wrapper-web-gray': !$route.meta.hideBodyBg, 'wrapper-web-famous-pedia-new': curWebFamousPediaNew}">
        <!-- 0. 书法背景部分 -->
        <div ref="webbg" v-show="!$route.meta.hideBodyBg" class="wrapper-web-bg"></div>
        <!-- 1.1 顶部导航栏:web端 -->
        <web-top-bar v-if="!$route.meta.hideTopBar"></web-top-bar>
        <!-- 1. 路由匹配到的组件将渲染在这里 -->
        <div class="wrapper-content wrapper-web" v-bind:class="{'wrapper-web-wide': $route.meta.hideTopBar}">
            <router-view></router-view>
        </div>

        <!-- 5. 登录弹框 -->
        <web-login-pop></web-login-pop>
        <web-login-code-pop></web-login-code-pop>
        <!-- 6. 举报弹框 -->
        <web-report-pop></web-report-pop>
        <!-- 7. 列表弹框 -->
        <div v-if="showWebFamousPediaPop" class="layout-overlay layout-overlay-blank" @click="clickWebFamousPediaOverlay"></div>
        <web-my-famous-pedia-pop v-if="showWebFamousPediaPop"></web-my-famous-pedia-pop>

        <!-- 2. loading层 -->
        <div id="loading" class="layout-overlay layout-overlay-blank loading-page" style="display: none">
            <div class="loading-content">
                <div class="lds-default-gray-box">
                    <div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import WebTopBar from './components/WebTopBar.vue'
import WebLoginPop from './layouts/web/WebLoginPop.vue'
import WebLoginCodePop from './layouts/web/WebLoginCodePop.vue'
import WebReportPop from './layouts/web/WebReportPop.vue'
import WebMyFamousPediaPop from './layouts/web/WebMyFamousPediaPop.vue'
import { CONFIG } from './modules/config'
import { UTILS } from './modules/utils'
import { SHARE } from './modules/share'
export default {
    name: "App",
    components: { WebTopBar, WebLoginPop, WebLoginCodePop, WebReportPop, WebMyFamousPediaPop },
    computed: {
        showDownloadReminder() {
            return this.$store.state.reminder.showDownloadReminder
        },
        showVersionReminder() {
            return this.$store.state.reminder.showVersionReminder
        },
        showWebFamousPediaPop() {
            return this.$store.state.weblogin.showWebFamousPediaPop
        },
        curWebFamousPediaNew() {
            return this.$store.state.weblogin.curWebFamousPediaNew;
        },
    },
    data() {
        return {
            CONFIG: CONFIG,
            curPath: ''
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initWebDom();
        }, 20);
    },
    methods: {
        initWebDom() {
            this.$el.style.minHeight = innerHeight + 'px';
            this.$refs.webbg.style.width = innerWidth + 'px';
            this.$refs.webbg.style.height = innerHeight*1.1 + 'px';
            this.curPath = this.$router.history.current.path;
            if(this.curPath == '/') {
                this.$router.replace('/webhome');
            }
        },
        clickWebFamousPediaOverlay() {
            this.$store.state.weblogin.curWebFamousPediaNew = false;
            this.$store.state.weblogin.showWebFamousPediaPop = false;
            this.$store.state.weblogin.curWebFamousPediaMenu = 0;
        }
    }
};
</script>
